import { makeStyles } from "tss-react/mui";
import { Box, IconButton, Fade, Typography } from "@mui/material";
import { useCallback, useMemo } from "react";
import { Close as CloseIcon } from "@mui/icons-material";

const useStyles = makeStyles()(
  (theme) => ({
    root: {
      height: "56px",
      width: "56px",
      zIndex: 100
    },
    buttonContainer: {
      height: "56px",
      width: "56px",
      borderRadius: theme.spacing(1),
      background: theme.palette.background.default,
      boxShadow: "3px 10px 3px 0px rgba(0, 0, 0, 0.00), 2px 6px 3px 0px rgba(0, 0, 0, 0.01), 1px 4px 2px 0px rgba(0, 0, 0, 0.05), 0px 2px 2px 0px rgba(0, 0, 0, 0.09), 0px 0px 1px 0px rgba(0, 0, 0, 0.10)"
    },
    iconButton: {
      width: "100%",
      height: "100%",
    },
    contentContainer: {
      position: "absolute",
      top: 0,
      left: 0,
      zIndex: 99,
      width: "300px",
      height: `calc(100vh - ${theme.spacing(3)})`,
      borderRadius: theme.spacing(1),
      background: theme.palette.background.default,
      boxShadow: "3px 10px 3px 0px rgba(0, 0, 0, 0.00), 2px 6px 3px 0px rgba(0, 0, 0, 0.01), 1px 4px 2px 0px rgba(0, 0, 0, 0.05), 0px 2px 2px 0px rgba(0, 0, 0, 0.09), 0px 0px 1px 0px rgba(0, 0, 0, 0.10)",
    },
    containerContainerRight: {
      right: 0,
      left: "unset"
    },
    contentHeaderContainer: {
      display: "flex",
      flexDirection: "row",
      alignItems: "center",
      justifyContent: "space-between",
      paddingLeft: theme.spacing(2),
      paddingRight: theme.spacing(1),
      width: "100%",
      borderBottom: `1px solid ${theme.palette.divider}`,
      height: "48px"
    },
    contentBody: {
      position: "absolute",
      top: "48px",
      left: 0,
      width: "100%",
      height: "calc(100% - 48px)",
      overflowX: "hidden",
      overflowY: "auto",
      scrollbarGutter: "stable both-edges",
    },
  })
);

export default function ContainerButton(props) {
  const { className, icon, title, right, width, expanded, setExpanded, slim } = props;
  const { classes } = useStyles();

  const onExpandClick = useCallback(() => {
    setExpanded(true);
  }, [])

  const onCloseClick = useCallback(() => {
    setExpanded(false);
  }, []);

  const containerStyles = useMemo(() => (slim ? { width: "calc(100vw - 24px)", left: "12px", top: "12px", right: "revert", position: "fixed" } : { width }), [width, slim]);

  return (
    <Box className={`${classes.root} ${className || ""}`}>

      <Fade in={!expanded}>
        <Box className={classes.buttonContainer}>
          <IconButton className={classes.iconButton} size="large" onClick={onExpandClick} color="primary">
            {icon}
          </IconButton>
        </Box>
      </Fade>

      <Fade in={expanded}>
        <Box className={`${classes.contentContainer} ${!!right ? classes.containerContainerRight : ""}`} style={containerStyles}>
          <Box className={classes.contentHeaderContainer}>
            <Typography variant="subtitle1">{title}</Typography>
            <IconButton onClick={onCloseClick} size="small">
              <CloseIcon />
            </IconButton>
          </Box>
          {
            expanded ? (
              <Box className={classes.contentBody}>
                {props.children}
              </Box>
            ) : null
          }
        </Box>
      </Fade>

    </Box>
  );
}



export function OperationsMapButton(props) {
  const { className, icon, onClick } = props;
  const { classes } = useStyles();

  return (
    <Box className={`${classes.buttonContainer} ${className || ""}`}>
      <IconButton className={classes.iconButton} size="large" onClick={onClick} color="primary">
        {icon}
      </IconButton>
    </Box>
  );
}
